export var UploadErrorType;
(function (UploadErrorType) {
    UploadErrorType["REQUIRED_FIELD"] = "REQUIRED_FIELD";
    UploadErrorType["INVALID_VALUE"] = "INVALID_VALUE";
    UploadErrorType["INVALID_PARENT_ORG"] = "INVALID_PARENT_ORG";
    UploadErrorType["CPM_VALIDATION"] = "CPM_VALIDATION";
    UploadErrorType["INVALID_DATE_FORMAT"] = "INVALID_DATE_FORMAT";
    UploadErrorType["SSP_ERROR"] = "SSP_ERROR";
    UploadErrorType["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    UploadErrorType["UNKNOWN"] = "UNKNOWN";
})(UploadErrorType || (UploadErrorType = {}));
export function mapStructuredError(error) {
    return {
        row: error.row,
        column: error.column,
        sheet: error.sheet,
        errorType: error.error_type || UploadErrorType.UNKNOWN,
        userFriendlyMessage: error.message,
        fixInstructions: error.fix_instructions
    };
}
function isStructuredError(value) {
    return (typeof value === "object" &&
        value !== null &&
        typeof value.message === "string");
}
function legacyErrorToParsed(error) {
    return {
        errorType: UploadErrorType.UNKNOWN,
        userFriendlyMessage: error
    };
}
export function generateSummary(errors) {
    if (errors.length === 0) {
        return "Template upload failed";
    }
    if (errors.length === 1) {
        const error = errors[0];
        const rowInfo = error.row ? `Row ${error.row}: ` : "";
        return `${rowInfo}${error.userFriendlyMessage}`;
    }
    return `Found ${errors.length} errors in your template. Please fix these and re-upload.`;
}
export function formatBulkUploadErrors(backendErrors) {
    if (!backendErrors || backendErrors.length === 0) {
        return {
            summary: "Template upload failed",
            errors: []
        };
    }
    const parsed = backendErrors
        .map((err) => {
        if (isStructuredError(err)) {
            return mapStructuredError(err);
        }
        if (typeof err === "string" && err.trim().length > 0) {
            return legacyErrorToParsed(err);
        }
        return null;
    })
        .filter((e) => e !== null);
    return {
        summary: generateSummary(parsed),
        errors: parsed
    };
}
//# sourceMappingURL=errorFormatter.js.map